module.exports = __webpack_public_path__ + "img/banner.e50dcd21.png";